import {memo} from "react";
import Picture from "../../../components/common/Picture";

interface SideTitleSliderSectionProps {
    id: string;
    title: string;
    description?: string;
    isDark?: boolean;
    isLeftAligned?: boolean;
    image: string;
}

export const MembershipSection = memo(({
                                           id,
                                           title,
                                           description,
                                           isDark = false,
                                           isLeftAligned = true,
                                           image
                                       }: SideTitleSliderSectionProps) => {
    return (
        <section
            id={id}
            className={`snap-section h-auto ${isDark ? 'bg-dark-mode' : 'bg-ivory'} py-6 sm:py-8 lg:py-12 px-4 sm:px-6 lg:px-8`}
        >
            <div
                className={`flex flex-col lg:flex-row justify-center items-center h-full gap-6 sm:gap-8 lg:gap-12
                ${!isLeftAligned ? 'lg:flex-row-reverse' : ''}`}
            >
                {/* Text Section */}
                <div
                    className={`flex flex-col justify-center gap-3 sm:gap-4 lg:gap-6 w-full lg:w-[35%] text-center lg:text-start
                    ${!isLeftAligned ? 'lg:text-end' : ''}`}
                >
                    <h2 className={`heading-font text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl leading-tight
                        ${isDark ? 'text-ivory' : 'text-royal-pine'}`}
                    >
                        {title}
                    </h2>
                    {description && (
                        <p
                            className={`text-sm sm:text-base lg:text-lg leading-relaxed px-2 lg:px-0 ${isDark ? 'text-ivory' : 'text-royal-pine'}`}
                        >
                            {description}
                        </p>
                    )}
                </div>

                {/* Image Section */}
                <div
                    className="w-full lg:flex-1 h-48 sm:h-56 md:h-64 lg:h-80 xl:max-h-96 rounded-lg overflow-hidden shadow-lg group">
                    <Picture
                        {...(image.toLowerCase().endsWith('.webp') ? { webpSrc: image } : image.toLowerCase().endsWith('.png') ? { pngSrc: image } : { jpgSrc: image })}
                        alt={`${title} membership benefits and features`}
                        className="w-full h-full object-cover transition-all duration-500 group-hover:scale-105"
                        onErrorSrc={`https://placehold.co/600x400/153D40/C6A375?text=${encodeURIComponent(title)}`}
                    />
                </div>
            </div>
        </section>
    );
});

MembershipSection.displayName = 'MembershipSection';